import * as angular from "angular";
import {LogisticsVehicle} from "../models/logistics-vehicle.model";
import {Document} from "../../commons/models/document.model";
import {Reminder} from "../../commons/models/reminder.model";
import {LogisticsVehicleExportQueryModel} from "../models/logistics-vehicle-export-query.model";

export class LogisticsVehicleRequestsService {

  /* @ngInject */
  constructor(private LogisticsVehicleAPI, private $logisticsVehicle) {
  }

  getMany(ids) {
    const api = this.LogisticsVehicleAPI.actions.getMany;
    return this.$$call(api, {ids: ids}, {}, {});
  }

  createOne(vehicle: LogisticsVehicle) {
    const api = this.LogisticsVehicleAPI.actions.create;
    return this.$$call(api, {}, vehicle, {});
  }

  updateOne(logisticsVehicle: LogisticsVehicle) {
    const api = this.LogisticsVehicleAPI.actions.update;
    return this.$$call(api, {}, logisticsVehicle, {id: logisticsVehicle.id});
  }

  //////////////////////////////////////// DOCUMENTS ////////////////////////////////////////

  getDocuments(vehicleId: string) {
    const api = this.LogisticsVehicleAPI.actions.getDocuments;
    return this.$$call(api, {}, {}, {id: vehicleId});
  }

  createDocument(document: Document, vehicleId: string) {
    const api = this.LogisticsVehicleAPI.actions.createDocument;
    return this.$$call(api, {}, document, {id: vehicleId});
  }

  updateDocument(document: Document, vehicleId: string) {
    const api = this.LogisticsVehicleAPI.actions.updateDocument;
    return this.$$call(api, {}, document, {id: vehicleId, documentId: document.id});
  }

  deleteDocument(documentId: string, vehicleId: string) {
    const api = this.LogisticsVehicleAPI.actions.deleteDocument;
    return this.$$call(api, {}, {}, {id: vehicleId, documentId: documentId});
  }

  exportLogisticsVehicles(query: LogisticsVehicleExportQueryModel) {
    const api = this.LogisticsVehicleAPI.actions.exportLogisticsVehicles;
    return this.$$call(api, query, {}, {});
  }

  deleteLogisticsVehicles(logisticVehicleId: string) {
    const api = this.LogisticsVehicleAPI.actions.deleteLogisticsVehicles;
    return this.$$call(api, {}, {}, {id: logisticVehicleId});
  }

  getVehicleResources(logisticVehicleId: string) {
    const api = this.LogisticsVehicleAPI.actions.getVehicleResources;
    return this.$$call(api, {}, {}, {id: logisticVehicleId});
  }

  //////////////////////////////////////// REMINDERS ////////////////////////////////////////

  getReminders(vehicleId: string) {
    const api = this.LogisticsVehicleAPI.actions.getReminders;
    return this.$$call(api, {}, {}, {id: vehicleId});
  }

  createReminder(reminder: Reminder, vehicleId: string) {
    const api = this.LogisticsVehicleAPI.actions.createReminder;
    return this.$$call(api, {}, reminder, {id: vehicleId});
  }

  updateReminder(reminder: Reminder, vehicleId: string) {
    const api = this.LogisticsVehicleAPI.actions.updateReminder;
    return this.$$call(api, {}, reminder, {id: vehicleId, reminderId: reminder.id});
  }

  deleteReminder(reminderId: string, vehicleId: string) {
    const api = this.LogisticsVehicleAPI.actions.deleteReminder;
    return this.$$call(api, {}, {}, {id: vehicleId, reminderId: reminderId});
  }

  //////////////////////////////////////// BINDINGS ////////////////////////////////////////

  bindToAgent(agentId: string, logisticsVehicleIds: string[], forceUnbind?) {
    const api = this.LogisticsVehicleAPI.actions.bindToAgent;
    return this.$$call(api, {
      agentId: agentId,
      logisticsVehicleIds: logisticsVehicleIds,
      forceUnbind: forceUnbind
    }, {}, {});
  }

  unbindVehicle(agentId) {
    const api = this.LogisticsVehicleAPI.actions.unbindVehicle;
    return this.$$call(api, {agentId: agentId}, {}, {});
  }

  getCurrentBoundedByAgent(agentId) {
    const api = this.LogisticsVehicleAPI.actions.getCurrentBoundedByAgent;
    return this.$$call(api, {agentId: agentId}, {}, {});
  }

  // ******************************
  // Internal methods
  // ******************************

  private $$call(_apiCall, _params, _data, _options, vehicleId?) {
    return this.$logisticsVehicle(vehicleId).$call(_apiCall, _params, _data, _options);
  }

}

angular
  .module('bringoz.admin.logistics-vehicle')
  .service('logisticsVehicleRequestsService', LogisticsVehicleRequestsService);
